module.exports = __webpack_public_path__ + "static/media/Precision-IQ_TMX-2050.3f34c4e9.png";